import{breakpoints as o}from"../props/prop-def.js";function i(e){return typeof e=="object"&&Object.keys(e).some(s=>o.includes(s))}export{i as isResponsiveObject};
//# sourceMappingURL=is-responsive-object.js.map
